export default Object.freeze({
  Start: 'START',
  End: 'END',
});
